import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import HomePage from "../HomePage";
import HomePage2 from "../HomePage2";
import HomePage3 from "../HomePage3";
import HomePage4 from "../HomePage4";
import HomePage5 from "../HomePage5";
import HomePage6 from "../HomePage6";
import TeamSinglePage from "../TeamSinglePage";
import StoryPage from "../StoryPage";
import AccomodationPage from "../AccomodationPage";
import RSVPPage from "../RSVPPage";
import GalleryPage from "../GalleryPage";
import PlannerPage from "../PlannerPage";
import BrideGroomPage from "../BrideGroomPage";
import PortfolioGridPage from "../PortfolioGridPage";
import PortfolioMasonaryPage from "../PortfolioMasonaryPage";
import ShopPage from "../ShopPage";
import CheckoutPage from "../CheckoutPage";
import CartPage from "../CartPage";
import OrderRecived from "../OrderRecived";
import ProjectSinglePage from "../ProjectSinglePage";
import BlogPage from "../BlogPage";
import BlogPageLeft from "../BlogPageLeft";
import BlogPageFullwidth from "../BlogPageFullwidth";
import BlogDetails from "../BlogDetails";
import BlogDetailsFull from "../BlogDetailsFull";
import EventDetailsFull from "../EventDetailsFull";
import BlogDetailsLeftSiide from "../BlogDetailsLeftSiide";
import ErrorPage from "../ErrorPage";
import ContactPage from "../ContactPage";
import ProductSinglePage from "../ProductSinglePage";
import ServicePage from "../ServicePage";
import SeviceSinglePage from "../SeviceSinglePage";
import PricingPage from "../PricingPage";
import ComingSoonPage from "../ComingSoonPage";
import LoginPage from "../LoginPage";
import SignUpPage from "../SignUpPage";
import ForgotPassword from "../ForgotPassword";
import AdminPage from "../AdminPage";
import AdminUpdateBlog from "../AdminUpdateBlog";
import AdminUpdateProduct from "../AdminUpdateProduct";
import PackageSinglePage from "../PackageSinglePage";
import Events from "../Events";
import ProgressPage from "../ProgressPage";
import PersonPage from "../PersonPage";
import AdminUpdateCampaginAppointmentForm from "../../components/AdminUpdateCampaginAppointmentForm";
import DashboardPage from "../DashboardPage";
import LibraryPage from "../LibraryPage";
import TermsPage from "../TermsPage";
import CelebrationPage from "../CelebrationPage";
import EditPersonPage from "../EditPersonPage";
import GoalsEditorPage from "../GoalsEditorPage";
import PersonTablePage from "../PersonTablePage";
import PersonTreePage from "../PersonTreePage";
import ProfilePageMainModern from "../ProfilePageMainModern";
import SettingsPageMainModern from "../SettingsPageMainModern";
import SettingsTestPage from "../../components/SettingsTestPage";
import AdminDashboardPage from "../AdminDashboardPage";
import CampaignBucurestiPage from "../CampaignBucurestiPage";
import EventsPage from "../EventsPage";
import EventGallery from "../../components/EventGallery";
import MisiunePage from "../MisiunePage";
import DesprePage from "../DesprePage";

const AllRoute = () => {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route path="/home" component={HomePage} />
          <Route path="/home2" component={HomePage2} />
          <Route path="/home3" component={HomePage3} />
          <Route path="/home4" component={HomePage4} />
          <Route path="/home5" component={HomePage5} />
          <Route path="/home6" component={HomePage6} />
          <Route path="/cart" component={CartPage} />
          <Route path="/story" component={StoryPage} />
          <Route path="/accomodation" component={AccomodationPage} />
          <Route path="/rsvp" component={RSVPPage} />
          <Route path="/gallery" component={GalleryPage} />
          <Route path="/planner" component={PlannerPage} />
          <Route path="/groom-bride" component={BrideGroomPage} />
          <Route path="/pricing" component={PricingPage} />
          <Route path="/coming" component={ComingSoonPage} />
          <Route path="/portfolio-grid" component={PortfolioGridPage} />
          <Route path="/portfolio-masonary" component={PortfolioMasonaryPage} />
          <Route path="/shop" component={ShopPage} />
          <Route path="/service" component={ServicePage} />
          <Route path="/checkout" component={CheckoutPage} />
          <Route path="/order_received" component={OrderRecived} />
          <Route path="/product-single/:id" component={ProductSinglePage} />
          <Route path="/team-single/:id" component={TeamSinglePage} />
          <Route path="/project-single/:id" component={ProjectSinglePage} />
          <Route path="/service-single/:id" component={SeviceSinglePage} />
          <Route path="/package-single/:id" component={PackageSinglePage} />
          <Route path="/404" component={ErrorPage} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/blog-single/:id" component={BlogDetails} />
          <Route
            path="/blog-single-left-sidebar/:id"
            component={BlogDetailsLeftSiide}
          />
          <Route
            path="/blog-single-fullwidth/:id"
            component={BlogDetailsFull}
          />
          <Route exact path="/despre-noi" component={DesprePage} />
          <Route exact path="/misiune" component={MisiunePage} />
          <Route exact path="/evenimente" component={EventsPage} />
          <Route
            exact
            path="/evenimente/mostre"
            render={() => <Events campaignId="mostre" />}
          />
          <Route
            exact
            path="/campanie/mostre"
            render={() => <Redirect to="/evenimente/mostre" />}
          />
          <Route
            exact
            path="/consultanta"
            render={() => <EventDetailsFull eventId="consultanta" />}
          />
          <Route
            exact
            path="/evenimente/consultanta"
            render={() => <Redirect to="/consultanta" />}
          />
          <Route
            path="/evenimente/:id"
            component={EventDetailsFull}
          />
          <Route
            path="/campanie/bucuresti"
            component={CampaignBucurestiPage}
          />
          <Route
            path="/eveniment/:id/galerie"
            component={EventGallery}
          />
          <Route
            path="/eveniment/:id"
            component={Events}
          />
          <Route path="/blog" component={BlogPageFullwidth} />
          <Route path="/admin/blog/update/:id" component={AdminUpdateBlog} />
          <Route
            path="/admin/product/update/:id"
            component={AdminUpdateProduct}
          />
          <Route path="/blog-left-sidebar" component={BlogPageLeft} />
          <Route path="/login" component={LoginPage} />
          <Route path="/register" component={SignUpPage} />
          <Route path="/librarie" component={LibraryPage} />
          <Route path="/terms" component={TermsPage} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/admin" component={AdminPage} />
          <Route path="/admin-dashboard" component={AdminDashboardPage} />
          {/* <Route path="/appointment" component={AppointmentPage} /> */}

          <Route path="/progressbar" component={ProgressPage} />
          <Route path="/person" component={PersonPage} />
          <Route path="/dashboard" component={DashboardPage} />
          <Route path="/celebration" component={CelebrationPage} />
          <Route path="/editperson" component={EditPersonPage} />
          <Route path="/goalseditor" component={GoalsEditorPage} />
          <Route path="/persontable" component={PersonTablePage} />
          <Route path="/persontree" component={PersonTreePage} />
          <Route exact path="/profil" component={ProfilePageMainModern} />
          <Route exact path="/profile" render={() => <Redirect to="/profil" />} />
          <Route path="/settings" component={SettingsPageMainModern} />
          <Route path="/settings-test" component={SettingsTestPage} />

          <Route path="/admin/appointment/update/:id" component={AdminUpdateCampaginAppointmentForm} />
        </Switch>
      </Router>
    </div>
  );
};

export default AllRoute;
